<template>
  <div class="request-contact-info-main-section mt-4">
    <section-title
      content="Dirección postal a recibir contestación"
      :has-line="true"
    />
    <div class="px-4 pb-4">
      <div class="row mt-4">
        <div class="col-md">
          <validation-provider
            v-slot="{ errors }"
            name="addressLine1"
            rules="required"
          >
            <label class="data-title mb-n2">Dirección (Línea 1):</label>
            <span v-if="isReadOnly" class="data-content d-block">
              {{ model.addressLine1 | empty }}
            </span>
            <custom-input
              v-else
              v-model="model.addressLine1"
              :custom-error-msg="'La dirección (línea 1) es requerida.'"
              :disabled="isReadOnly"
              :error="errors[0]"
            />
          </validation-provider>
        </div>
        <div class="col-md">
          <validation-provider
            v-slot="{ errors }"
            name="municipalityPostalAddress"
            rules="required"
          >
            <label class="data-title mb-n2">Munipicio:</label>
            <span v-if="isReadOnly" class="data-content d-block">
              {{ municipalitySelectedName | empty }}
            </span>
            <custom-drop-down
              v-else
              v-model="municipalitySelected"
              custom-error-msg="El municipio es requerido."
              :disabled="isReadOnly"
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              :options="municipalities"
              placeholder="Seleccione"
              @input="onChangeMunicipality"
            />
          </validation-provider>
        </div>
        <div class="col-md">
          <label class="data-title mb-n2">País:</label>
          <span v-if="isReadOnly" class="data-content d-block">
            {{ model.state | empty }}
          </span>
          <input v-else class="form-control" disabled :value="model.state" />
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-4">
          <label class="data-title mb-n2">Dirección (Línea 2):</label>
          <span v-if="isReadOnly" class="data-content d-block">
            {{ model.addressLine2 | empty }}
          </span>
          <custom-input
            v-else
            v-model="model.addressLine2"
            :disabled="isReadOnly"
          />
        </div>
        <div class="col-md-4">
          <validation-provider
            v-slot="{ errors }"
            name="postalCode"
            rules="required"
          >
            <label class="data-title mb-n2">Código Postal:</label>
            <span v-if="isReadOnly" class="data-content d-block">
              {{ model.postalCode | empty }}
            </span>
            <custom-input
              v-else
              v-model="model.postalCode"
              :custom-error-msg="'El código postal es requerido.'"
              :disabled="isReadOnly"
              :error="errors[0]"
              type="number"
            />
          </validation-provider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomInput from 'CustomInput';
import SectionTitle from 'SectionTitle';
import CustomDropDown from 'custom-drop-down';

import { ValidationProvider } from 'vee-validate';
export default {
  name: 'RequestPostalAddressInfo',
  components: {
    CustomInput,
    CustomDropDown,
    SectionTitle,
    ValidationProvider,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    municipalities: {
      type: Array,
      required: true,
      default: () => [],
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      municipalitySelected: null,
    };
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    municipalitySelectedName() {
      return this.municipalitySelected?.name;
    },
  },
  methods: {
    onChangeMunicipality(item) {
      this.model.municipalityId = item ? item.id : null;
    },
  },
  watch: {
    'model.municipalityId': function(value) {
      if (this.municipalitySelected) return;
      if (!value) {
        this.municipalitySelected = null;
      }

      this.municipalitySelected = this.municipalities.find(
        (y) => y.id == value
      );
    },
  },
};
</script>
